import { useContext } from "react";
import { SharedObjectContext } from "./SharedObjectContext";

const useSharedObject = () => useContext(SharedObjectContext);

export default useSharedObject;
